import { Box } from '@mui/material';
import SpreedlyIFrameField from '../../fields/spreedly-iframe-field.component';
import {
  spreedlyCvvName,
  spreedlyNumberName,
} from '../../spreedly-form.component';
import { useTranslation } from 'react-i18next';

const CVVForm = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 1fr"
      gap={theme => theme.spacing(1)}
      data-testid="SpreedlyCard.Container"
    >
      <SpreedlyIFrameField
        name={spreedlyNumberName}
        label={t('checkout.payment.spreedly.fields.cardNumber.label')}
        id="spreedly-number-test"
      />
      <SpreedlyIFrameField
        name={spreedlyCvvName}
        label={t('checkout.payment.spreedly.fields.cvv.label')}
        id="spreedly-cvv-test"
      />
    </Box>
  );
};

export default CVVForm;
